import { MenuResponse } from "@/main/models/response/menu";

export enum MenuTypes {
	GET_MENU = "@menu/GET_MENU",
	SAVE_MENU = "@menu/SAVE_MENU",
	RESET_REDUCER_MENU = "@menu/RESET_REDUCER_MENU",
	SET_MENU_ITEM_SELECTED = "@menu/SET_MENU_ITEM_SELECTED",
	SET_OPEN_MENU = "@menu/SET_OPEN_MENU",
}

export interface MenuState {
	readonly menu: {
		data: MenuResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly menuItemSelected: string;
	readonly open: boolean;
}

export interface GetMenu {
	type: typeof MenuTypes.GET_MENU;
}

export interface SaveMenu {
	type: typeof MenuTypes.SAVE_MENU;
	payload: {
		data: MenuResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerMenu {
	type: typeof MenuTypes.RESET_REDUCER_MENU;
}

export interface SetMenuItemSelected {
	type: typeof MenuTypes.SET_MENU_ITEM_SELECTED;
	payload: { menuItemSelected: string };
}

export interface SetOpenMenu {
	type: typeof MenuTypes.SET_OPEN_MENU;
	payload: { open: boolean };
}

export type MenuActionTypes = GetMenu | SaveMenu | ResetReducerMenu | SetMenuItemSelected | SetOpenMenu;
